module.exports = __webpack_public_path__ + "static/avatar2-bd19575c2ea2c2fe35283903911e8ea8.jpg";